export const SITE_URL = "https://universedecoder.in";

const organizationId = `${SITE_URL}/#organization`;
const websiteId = `${SITE_URL}/#website`;

const organization = {
  "@type": "Organization",
  "@id": organizationId,
  name: "UniverseDecoder",
  url: `${SITE_URL}/`,
  logo: {
    "@type": "ImageObject",
    url: `${SITE_URL}/logo512.png`,
  },
  email: "srushtee@universedecoder.in",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Plot 20, Vaibhav Anand Society, Shambhunagar, Faras",
    addressLocality: "Nagpur",
    addressRegion: "Maharashtra",
    postalCode: "440030",
    addressCountry: "IN",
  },
};

const website = {
  "@type": "WebSite",
  "@id": websiteId,
  url: `${SITE_URL}/`,
  name: "UniverseDecoder",
  description:
    "UniverseDecoder builds clear, useful apps for everyday life. Muscle Up, a no-nonsense workout tracker and gym log, is coming 15 December 2026.",
  publisher: { "@id": organizationId },
  inLanguage: "en",
};

const routes = [
  {
    path: "/",
    title: "UniverseDecoder — Apps for everyday life",
    description:
      "UniverseDecoder builds clear, useful apps for everyday life. Muscle Up, a no-nonsense workout tracker and gym log, is coming 15 December 2026.",
    image: "/og-home.png",
    imageAlt:
      "UniverseDecoder. Decoding life, one thing at a time. Muscle Up comes 15 December 2026.",
    themeColor: "#0b1021",
    favicon: "/favicon.ico",
    robots: "index, follow",
    sitemap: true,
    priority: "1.0",
    lastmod: "2026-11-02",
  },
  {
    path: "/about",
    title: "About UniverseDecoder — Digital product studio",
    description:
      "UniverseDecoder is a digital product studio making practical apps with clear design. Muscle Up, our workout tracker, is coming 15 December 2026.",
    image: "/og-home.png",
    imageAlt: "UniverseDecoder, a digital product studio.",
    themeColor: "#0b1021",
    favicon: "/favicon.ico",
    robots: "index, follow",
    sitemap: true,
    priority: "0.7",
    lastmod: "2026-11-02",
  },
  {
    path: "/muscleUp",
    title: "Muscle Up — Workout Tracker & Gym Log",
    description:
      "Train, track, and get stronger. Muscle Up is a no-nonsense workout logger for the long game, coming to Google Play on 15 December 2026.",
    image: "/og-muscle-up.png",
    imageAlt:
      "Muscle Up. Train. Track. Get stronger. Coming 15 December 2026.",
    themeColor: "#10120f",
    favicon: "/muscleUp.ico",
    robots: "index, follow",
    sitemap: true,
    priority: "0.9",
    lastmod: "2026-11-02",
  },
  {
    path: "/muscleUp/privacy-policy",
    title: "Privacy Policy — Muscle Up",
    description:
      "How Muscle Up collects, uses, and handles your account, workouts, and subscription information. A plain-language policy from UniverseDecoder.",
    image: "/og-muscle-up.png",
    imageAlt: "Muscle Up by UniverseDecoder.",
    themeColor: "#10120f",
    favicon: "/muscleUp.ico",
    robots: "index, follow",
    sitemap: true,
    priority: "0.3",
    lastmod: "2026-11-02",
  },
  {
    path: "/muscleUp/terms-and-conditions",
    title: "Terms and Conditions — Muscle Up",
    description:
      "The rules for using Muscle Up: accounts, workouts, subscriptions, and your rights. Clear terms from UniverseDecoder before you start.",
    image: "/og-muscle-up.png",
    imageAlt: "Muscle Up by UniverseDecoder.",
    themeColor: "#10120f",
    favicon: "/muscleUp.ico",
    robots: "index, follow",
    sitemap: true,
    priority: "0.3",
    lastmod: "2026-11-02",
  },
  {
    path: "/muscleUp/our-philosophy",
    title: "Muscle Up — Workout Tracker & Gym Log",
    description:
      "Train, track, and get stronger. Muscle Up is a no-nonsense workout logger for the long game, coming to Google Play on 15 December 2026.",
    image: "/og-muscle-up.png",
    imageAlt:
      "Muscle Up. Train. Track. Get stronger. Coming 15 December 2026.",
    themeColor: "#10120f",
    favicon: "/muscleUp.ico",
    robots: "noindex, follow",
    canonicalPath: "/muscleUp",
    sitemap: false,
    priority: "0.0",
    lastmod: "2026-11-02",
  },
];

export function normalizePath(pathname) {
  if (!pathname) return "/";
  const path = pathname.split("?")[0].split("#")[0].replace(/\/+$/, "");
  return path || "/";
}

export function resolveRoute(pathname) {
  const path = normalizePath(pathname);
  return (
    routes.find((route) => route.path === path) || {
      path,
      title: "UniverseDecoder — Apps for everyday life",
      description:
        "UniverseDecoder builds clear, useful apps for everyday life. Muscle Up, a no-nonsense workout tracker and gym log, is coming 15 December 2026.",
      image: "/og-home.png",
      imageAlt: "UniverseDecoder.",
      themeColor: "#0b1021",
      favicon: "/favicon.ico",
      robots: "noindex, follow",
      sitemap: false,
      canonicalPath: "/",
    }
  );
}

export function absoluteUrl(pathname) {
  const path = normalizePath(pathname);
  return path === "/" ? `${SITE_URL}/` : `${SITE_URL}${path}`;
}

export function routeMeta(pathname) {
  const route = resolveRoute(pathname);
  const canonical = absoluteUrl(route.canonicalPath || route.path);
  const image = `${SITE_URL}${route.image}`;

  return {
    ...route,
    canonical,
    image,
    jsonLd: buildJsonLd(route, canonical),
  };
}

function crumb(name, path) {
  return { name, item: absoluteUrl(path) };
}

function breadcrumb(items) {
  return {
    "@type": "BreadcrumbList",
    "@id": `${items[items.length - 1].item}#breadcrumb`,
    itemListElement: items.map((entry, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: entry.name,
      item: entry.item,
    })),
  };
}

function webPage(route, canonical) {
  return {
    "@type": "WebPage",
    "@id": `${canonical}#webpage`,
    url: canonical,
    name: route.title,
    description: route.description,
    isPartOf: { "@id": websiteId },
    inLanguage: "en",
    breadcrumb: { "@id": `${canonical}#breadcrumb` },
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: `${SITE_URL}${route.image}`,
    },
  };
}

export function buildJsonLd(route, canonical) {
  const graph = [organization, website];
  const path = route.canonicalPath || route.path;

  if (path === "/") {
    graph.push(
      webPage(route, canonical),
      breadcrumb([crumb("Home", "/")])
    );
  } else if (path === "/about") {
    graph.push(
      webPage(route, canonical),
      breadcrumb([crumb("Home", "/"), crumb("About", "/about")])
    );
  } else if (path === "/muscleUp") {
    graph.push(
      {
        "@type": "SoftwareApplication",
        "@id": `${SITE_URL}/muscleUp#app`,
        name: "Muscle Up",
        url: `${SITE_URL}/muscleUp`,
        applicationCategory: "HealthApplication",
        operatingSystem: "Android",
        description: route.description,
        image: `${SITE_URL}${route.image}`,
        publisher: { "@id": organizationId },
      },
      webPage(route, canonical),
      breadcrumb([crumb("Home", "/"), crumb("Muscle Up", "/muscleUp")])
    );
  } else if (path === "/muscleUp/privacy-policy") {
    graph.push(
      webPage(route, canonical),
      breadcrumb([
        crumb("Home", "/"),
        crumb("Muscle Up", "/muscleUp"),
        crumb("Privacy Policy", path),
      ])
    );
  } else if (path === "/muscleUp/terms-and-conditions") {
    graph.push(
      webPage(route, canonical),
      breadcrumb([
        crumb("Home", "/"),
        crumb("Muscle Up", "/muscleUp"),
        crumb("Terms and Conditions", path),
      ])
    );
  }

  return {
    "@context": "https://schema.org",
    "@graph": graph,
  };
}

export function sitemapRoutes() {
  return routes.filter((route) => route.sitemap);
}

export function renderSeoBlock(meta) {
  const jsonLd = JSON.stringify(meta.jsonLd).replace(/</g, "\\u003c");

  return `    <title>${escapeHtml(meta.title)}</title>
    <meta name="description" content="${escapeHtml(meta.description)}" />
    <meta name="robots" content="${escapeHtml(meta.robots)}" />
    <meta name="author" content="UniverseDecoder" />
    <meta name="theme-color" content="${escapeHtml(meta.themeColor)}" />
    <meta name="color-scheme" content="dark" />
    <link rel="canonical" href="${escapeHtml(meta.canonical)}" />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="UniverseDecoder" />
    <meta property="og:locale" content="en_IN" />
    <meta property="og:title" content="${escapeHtml(meta.title)}" />
    <meta property="og:description" content="${escapeHtml(meta.description)}" />
    <meta property="og:url" content="${escapeHtml(meta.canonical)}" />
    <meta property="og:image" content="${escapeHtml(meta.image)}" />
    <meta property="og:image:secure_url" content="${escapeHtml(meta.image)}" />
    <meta property="og:image:type" content="image/png" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta property="og:image:alt" content="${escapeHtml(meta.imageAlt)}" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="${escapeHtml(meta.title)}" />
    <meta name="twitter:description" content="${escapeHtml(meta.description)}" />
    <meta name="twitter:image" content="${escapeHtml(meta.image)}" />
    <meta name="twitter:image:alt" content="${escapeHtml(meta.imageAlt)}" />
    <script type="application/ld+json" id="page-jsonld">${jsonLd}</script>`;
}

export function renderSitemap() {
  const urls = sitemapRoutes()
    .map(
      (route) => `  <url>
    <loc>${absoluteUrl(route.path)}</loc>
    <lastmod>${route.lastmod}</lastmod>
    <priority>${route.priority}</priority>
  </url>`
    )
    .join("\n");

  return `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urls}
</urlset>
`;
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}
